import { type Dispatch, type SetStateAction, useEffect } from 'react'

import { Container, LoadingHavaianas } from 'components'
import type { RequestMaterialsInterface } from 'container/SalesOrder/interfaces'
import { useParams } from 'react-router-dom'
import { useSelector } from 'store/store'

import UploadMaterials from '../UploadMaterials'
import Insert from './Insert'
import MaterialsList from './List'
import { ContentDivider, LoadingContainer, RowColumnTableItemsOrderStyled } from './styles'

export interface MaterialsProps {
  hasCustommer: boolean
  handleRequestMaterials: () => void
  requestMaterials: RequestMaterialsInterface
  setModalMaterialsLimit: Dispatch<SetStateAction<boolean>>
  user: string
  hasUnsavedOVConfig: boolean
  handleFieldModified: () => void
}
const Materials: React.FC<MaterialsProps> = ({
  hasCustommer,
  handleRequestMaterials,
  requestMaterials,
  setModalMaterialsLimit,
  user,
  hasUnsavedOVConfig,
  handleFieldModified,
}) => {
  const { orderNumber } = useParams()
  const {
    loadingMaterials: loading,
    emptyData,
    materialSearch,
    materialsLimitExceed,
  } = useSelector((state) => state.salesOrder)
  const { isHAVAConectaOrder } = useSelector((state) => state.ov)

  useEffect(() => {
    setModalMaterialsLimit(materialsLimitExceed)
  }, [materialsLimitExceed])

  return (
    <Container fullwidth={true}>
      <Insert hasOrderNumber={!!orderNumber} hasUnsavedOVConfig={hasUnsavedOVConfig} user={user} />

      {!!orderNumber && (
        <>
          <ContentDivider />
          {loading ? (
            <LoadingContainer>
              <LoadingHavaianas />
            </LoadingContainer>
          ) : (
            <>
              {emptyData && !materialSearch ? (
                <UploadMaterials disabled={isHAVAConectaOrder} />
              ) : (
                <RowColumnTableItemsOrderStyled>
                  <MaterialsList
                    handleFieldModified={handleFieldModified}
                    handleRequestMaterials={handleRequestMaterials}
                    hasCustommer={hasCustommer}
                    requestMaterials={requestMaterials}
                    user={user}
                  />
                </RowColumnTableItemsOrderStyled>
              )}
            </>
          )}
        </>
      )}
    </Container>
  )
}

export default Materials
